import { gql } from '@apollo/client';

export const FETCH_BILLING_EXPERIENCE_OPTIONS = gql`
  query Flex_FetchBillingExperienceOptions(
    $utilityId: Int!
    $enrollmentDataSourceName: EnrollmentOptionName!
    $communitySolarProjectGroupId: Int
  ) {
    billingExperienceOptions(
      utilityId: $utilityId
      enrollmentDataSourceName: $enrollmentDataSourceName
      communitySolarProjectGroupId: $communitySolarProjectGroupId
    ) {
      name
    }
  }
`;
